/**
 * Initialize Klarna Learn More modal for PDP
 * This handles the iframe modal that opens when clicking the "Learn more about Klarna" button
 */

// Create modal HTML if it doesn't exist
const ensureKlarnaModalExists = () => {
  // Check if modal already exists
  let klarnaModal = document.getElementById('klarna-pdp-modal');
  if (klarnaModal) return klarnaModal;

  // Create modal structure
  const modalHTML = `
    <div id="klarna-pdp-modal" class="klarna-qv-modal">
      <div class="klarna-qv-modal__container">
        <iframe id="klarna-pdp-iframe" class="klarna-qv-modal__iframe" allow="payment"></iframe>
      </div>
    </div>
  `;

  // Append modal to document body
  document.body.insertAdjacentHTML('beforeend', modalHTML);
  return document.getElementById('klarna-pdp-modal');
};

const initKlarnaModal = () => {
  // We ensure that doesn't run for international user experiences
  if (window.theme?.country_iso !== 'US') return;

  // Ensure modal exists in DOM
  const klarnaModal = ensureKlarnaModalExists();
  const klarnaIframe = document.getElementById('klarna-pdp-iframe');

  if (!klarnaModal || !klarnaIframe) {
    console.warn('[KlarnaPDP] Modal elements could not be created');
    return;
  }

  // Close modal function
  const closeModal = () => {
    const realModal = document.querySelector('.klarna-qv-modal');

    if (realModal) {
      realModal.classList.remove('klarna-qv-modal--open');
    }

    klarnaModal.classList.remove('klarna-qv-modal--open');
    klarnaIframe.src = ''; // Clear iframe

    // Re-enable body scroll
    document.body.style.overflow = '';
    document.documentElement.style.overflow = '';
  };

  // Handle button clicks with event delegation
  document.addEventListener('click', (event) => {
    const learnBtn = event.target.closest('.pdp-c-atc__klarna-learn-btn');
    if (!learnBtn) return;

    event.preventDefault();
    event.stopPropagation();

    // Get the learn more URL from the Klarna wrapper
    const klarnaWrapper = document.querySelector('[data-klarna-osm]');
    if (!klarnaWrapper) {
      console.warn('[KlarnaPDP] Klarna wrapper not found');
      return;
    }

    let learnUrl = klarnaWrapper.getAttribute('data-klarna-learn-url') || '';

    if (!learnUrl) {
      console.warn('[KlarnaPDP] No learn URL found');
      return;
    }

    // Modify the URL to change showButtons=false to showButtons=true
    try {
      const urlObj = new URL(learnUrl);
      const params = urlObj.searchParams;

      if (params.has('showButtons') && params.get('showButtons') !== 'true') {
        params.set('showButtons', 'true');
      }

      learnUrl = urlObj.toString();
    } catch (e) {
      console.warn('[KlarnaPDP] Failed to parse URL:', e);
    }

    // Clear iframe src first to force reload, then set new URL
    klarnaIframe.src = '';
    // Use setTimeout to ensure the clear happens before setting new src
    setTimeout(() => {
      klarnaIframe.src = learnUrl;
    }, 0);

    klarnaModal.classList.add('klarna-qv-modal--open');

    // Disable body scroll
    document.body.style.overflow = 'hidden';
    document.documentElement.style.overflow = 'hidden';
  });

  // Close on overlay click
  klarnaModal.addEventListener('click', (e) => {
    if (e.target === klarnaModal) {
      closeModal();
    }
  });

  // Listen for messages from Klarna iframe to close modal
  const handleKlarnaMessage = (event) => {
    try {
      let data = event.data;
      if (typeof data === 'string') {
        data = JSON.parse(data);
      }

      // Check if it's a CLOSE event from Klarna
      if (data && data.type === 'CLOSE') {
        closeModal();
      }
    } catch (e) {
      // Ignore parse errors from other messages
    }
  };

  // Listen for ESC key to close modal
  const handleEscKey = (event) => {
    if ((event.key === 'Escape' || event.keyCode === 27) && klarnaModal.classList.contains('klarna-qv-modal--open')) {
      closeModal();
    }
  };

  window.addEventListener('message', handleKlarnaMessage);
  document.addEventListener('keydown', handleEscKey);
};

export default initKlarnaModal;
